import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";

const SabbatRow = (props) => {
  function clickHandle(playcode, color, atype, action) {
    try {
      axiosConfig
        .get(
          "sabbat-changes.php?playcode=" +
            playcode +
            "&color=" +
            color +
            "&atype=" +
            atype +
            "&action=" +
            action
        )
        .then((response) => {
          console.log("response= ", response);
          if (response.data.message !== "") {
            alert(response.data.message);
          }
          console.log("Message: ", response.data.message);
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  return (
    <tr>
      <td>ثبات</td>
      <td></td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "notice", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.notice_blue)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "notice", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "foal", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.foal_blue)} (
        {numberToPersian(props.headInfo.foal_total_blue)}) &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "foal", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "out", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.out_blue)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "out", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "ndown", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.ndown_blue)} (
        {numberToPersian(props.headInfo.ndown_total_blue)}) &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "ndown", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "ground", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.ground_blue)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "blue", "ground", "decrease")
          }
        >
          -
        </span>
      </td>
      <td></td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "notice", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.notice_red)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "notice", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "foal", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.foal_red)} (
        {numberToPersian(props.headInfo.foal_total_red)}) &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "foal", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "out", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.out_red)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "out", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "ndown", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.ndown_red)} (
        {numberToPersian(props.headInfo.ndown_total_red)}) &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "ndown", "decrease")
          }
        >
          -
        </span>
      </td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "ground", "increase")
          }
        >
          +
        </span>
        &nbsp; {numberToPersian(props.headInfo.ground_red)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() =>
            clickHandle(props.headInfo.playcode, "red", "ground", "decrease")
          }
        >
          -
        </span>
      </td>
      <td></td>
    </tr>
  );
};

export default SabbatRow;
